import { FC, SVGProps } from 'react'

export const Discord: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="19"
    viewBox="0 0 24 19"
    fill="none"
    {...props}
  >
    <path
      d="M20.3452 1.72106C18.8261 1.01034 17.2019 0.493819 15.5038 0.199707C15.2953 0.576749 15.0516 1.08388 14.8836 1.4873C13.0785 1.21583 11.29 1.21583 9.51812 1.4873C9.35017 1.08388 9.101 0.576749 8.89058 0.199707C7.19066 0.493819 5.56457 1.01224 4.04553 1.72483C0.981614 6.3548 0.151037 10.8698 0.566327 15.3206C2.59848 16.8382 4.56787 17.7601 6.50404 18.3633C6.98209 17.7054 7.40844 17.006 7.77574 16.2689C7.07621 16.0031 6.40621 15.6751 5.77315 15.2943C5.9411 15.1698 6.10538 15.0398 6.2641 14.9059C10.1254 16.7119 14.3207 16.7119 18.1358 14.9059C18.2964 15.0398 18.4607 15.1698 18.6268 15.2943C17.9919 15.6769 17.32 16.005 16.6205 16.2708C16.9878 17.006 17.4123 17.7073 17.8922 18.3652C19.8302 17.7619 21.8015 16.8401 23.8336 15.3206C24.3209 10.161 23.0012 5.68745 20.3452 1.72106ZM8.30178 12.5834C7.14267 12.5834 6.1921 11.5013 6.1921 10.1836C6.1921 8.86584 7.12237 7.78188 8.30178 7.78188C9.48122 7.78188 10.4318 8.86394 10.4115 10.1836C10.4133 11.5013 9.48122 12.5834 8.30178 12.5834ZM16.0982 12.5834C14.939 12.5834 13.9885 11.5013 13.9885 10.1836C13.9885 8.86584 14.9187 7.78188 16.0982 7.78188C17.2776 7.78188 18.2281 8.86394 18.2078 10.1836C18.2078 11.5013 17.2776 12.5834 16.0982 12.5834Z"
      fill="currentColor"
    />
  </svg>
)
